import { useCallback } from "react";
import useSWR, { useSWRConfig } from "swr";
import { type TagWithDocuments } from "../types";
import { simpleFetcher } from "../fetcher";

const TAGS_KEY = "/api/v2/tags";
const TAGS_WITH_DOCUMENTS_KEY = "/api/v2/tags?includeDocuments=true";

export function useTags(includeDocuments = false) {
  const url = includeDocuments ? TAGS_WITH_DOCUMENTS_KEY : TAGS_KEY;
  const { mutate: mutateCache } = useSWRConfig();

  const swr = useSWR<TagWithDocuments[], Error>(url, simpleFetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
  });

  const mutate = useCallback(
    () =>
      Promise.all([
        mutateCache(TAGS_KEY),
        mutateCache(TAGS_WITH_DOCUMENTS_KEY),
      ]),
    [mutateCache],
  );

  return { ...swr, mutate };
}
